module.exports = __webpack_public_path__ + "static/media/completed.699969e3.svg";